import { Layout } from "widgets"
import { useRouteError } from "react-router-dom"

const RouteError = () => {
  const { statusText, message } = useRouteError()
  return <Layout className="error-page">{statusText || message}</Layout>
}

export default RouteError
